import { functions } from "../firebase";

export type DnsInstruction = {
  type: string;
  name: string;
  value: string;
  purpose: string;
};

// Which twin is primary. "www" is the default and what every domain connected
// before this option existed uses.
export type CanonicalHost = "apex" | "www";

// Who runs the coach's DNS, discovered from their _domainconnect record. Best
// effort on the function side, so it is absent whenever discovery found nothing.
export type DnsProviderInfo = {
  providerId: string;
  providerName: string;
  controlPanelUrl: string | null;
  supportsSync: boolean;
  supportsAsync: boolean;
  checkedAt: string;
};

export type CustomDomainStatus = {
  connected?: boolean;
  primaryHost?: string;
  isApex?: boolean;
  canonical?: CanonicalHost;
  status?: "pending_dns" | "verifying" | "active" | "error";
  dnsObserved?: boolean;
  lastError?: string | null;
  records?: DnsInstruction[];
  dnsProvider?: DnsProviderInfo;
};

export const connectLandingDomain = async (
  communityId: string,
  domain: string,
  canonical?: CanonicalHost
): Promise<CustomDomainStatus> => {
  const callable = functions.httpsCallable("connectLandingDomain");
  // Only sent when the caller chose one, so an unset value leaves the request
  // shape exactly as it was before the option existed.
  const res = await callable({ communityId, domain, ...(canonical ? { canonical } : {}) });
  return res.data as CustomDomainStatus;
};

export const checkLandingDomainStatus = async (
  communityId: string
): Promise<CustomDomainStatus> => {
  const callable = functions.httpsCallable("checkLandingDomainStatus");
  const res = await callable({ communityId });
  return res.data as CustomDomainStatus;
};

export const disconnectLandingDomain = async (
  communityId: string
): Promise<{ disconnected: boolean }> => {
  const callable = functions.httpsCallable("disconnectLandingDomain");
  const res = await callable({ communityId });
  return res.data as { disconnected: boolean };
};
